import script from "./RecordsStudents.vue?vue&type=script&setup=true&lang=js"
export * from "./RecordsStudents.vue?vue&type=script&setup=true&lang=js"

import "@/assets/common.css?vue&type=style&index=0&lang=css&external"
import "./RecordsStudents.vue?vue&type=style&index=1&id=3a8483b9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a8483b9"]])

export default __exports__